import { Typography } from "@mui/material";
import { CoreRadioGroup, RadioOption } from "../../../core";
import { useId } from "react";
import styles from "./index.module.css";

type RadioGroupSubItemProps = {
	radioOptions: RadioOption[];
	onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
	radioGroupDescription: string;
	selectedValue?: string;
};

export const RadioGroupSubItem = ({
	radioOptions,
	onChange,
	selectedValue,
	radioGroupDescription,
}: RadioGroupSubItemProps) => {
	const headerId = useId();
	return (
		<div className={styles.radioSubItemWrapper}>
			<Typography className={styles.description} id={headerId}>
				{radioGroupDescription}
			</Typography>
			<CoreRadioGroup
				radioGroupAriaLabelledby={headerId}
				onChange={onChange}
				selectedValue={selectedValue}
				radioOptions={radioOptions}
				radioLabelFontSize={14}
				sx={{ paddingLeft: "4px" }}
			/>
		</div>
	);
};
